import React, { FC, useRef, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../components/general/Icon';
import { Label } from '../../../components/general/forms/Label';
import { Colors } from '../../../styles/colors';
import { ErrorText } from './DefaultInput';

export interface SelectOptionProps {
  key: string | number;
  value: string;
}

export interface SelectProps {
  id: string;
  label?: string;
  hint?: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  type?: string;
  value?: string | number;
  options: SelectOptionProps[];
  // Error handling
  required?: boolean;
  disabled?: boolean;
  errorMessage?: string;
  hasError?: boolean;
}

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 2rem;
`;

export const InputInnerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  overflow: hidden;
`;

const DropDownWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const OpenSelectButton = styled.button`
  background-color: ${Colors.primary};
  padding: 1rem 0.75rem;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;


export const StyledSelect = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  font-family: 'Akkurat';
  text-indent: 1px;
  text-overflow: '';
  border: none;
  color: ${Colors.grayDark};
  background-color: ${Colors.background};
  font-size: 1rem;
  padding: 0 1rem;
  flex: 1;
  min-height: 3rem;
  
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${Colors.gray};
    font-size: 0.875rem;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    pointer-events: none;
    cursor: default;
  }
  
  &:hover {
    cursor: pointer;
  }
`;

export const DropDown: FC<SelectProps> = (props) => {
  const { required = false, disabled = false, hasError, errorMessage = 'Bitte treffen Sie eine Auswahl...' } = props;
  const [localError, setLocalError] = useState<boolean>(hasError);
  const selectElement = useRef(null);

  return (
    <InputWrapper>
      <Label hint={props.hint} for={props.id}>{props.label}</Label>
      <DropDownWrapper>
        <InputInnerWrapper>
          <StyledSelect
            ref={selectElement}
            id={props.id}
            value={props?.value}
            disabled={disabled}
            placeholder={`${props.placeholder ? props.placeholder : 'Hier eingeben'}`}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
              props.onChange(event);
            }}>
            {
              props?.options?.map((option) => {
                return <option value={option.key} key={option.value}>{option.value}</option>;
              })
            }
          </StyledSelect>
          <OpenSelectButton>
            <Icon icon={'chevron'} size={24} color={Colors.white}/>
          </OpenSelectButton>
        </InputInnerWrapper>
        {
          localError &&
          <ErrorText>{ errorMessage }</ErrorText>
        }
      </DropDownWrapper>
    </InputWrapper>
  );
};
